import type { WeeklyPointSummaryConfig } from "@/lib/schema";
import type { WidgetValidationResult } from "@/widgets/types";

export function validate(
  config: WeeklyPointSummaryConfig,
): WidgetValidationResult {
  const errors: Record<string, string> = {};
  if (config.label.trim().length === 0) {
    errors.label = "Etikett kan ikke være tom.";
  }
  if (config.rows.length === 0) {
    errors.rows = "Minst én rad kreves.";
  } else {
    const blank = config.rows.some((r) => r.name.trim().length === 0);
    if (blank) errors.rowNames = "Alle rader må ha et navn.";
    const empty = config.rows.some((r) => r.widgetIds.length === 0);
    if (empty) errors.rowWidgets = "Hver rad må ha minst én widget.";
    // A reference sits on at most one row. Configs saved before that rule
    // can still break it; they are flagged, not repaired, so Totalt never
    // changes without the user seeing why.
    const refs = config.rows.flatMap((r) => r.widgetIds);
    if (new Set(refs).size !== refs.length) {
      errors.rowDuplicates = "Samme widget står på flere rader.";
    }
  }
  if (Object.keys(errors).length === 0) return { ok: true };
  return { ok: false, errors };
}
